import moment from "moment";
import {rejectController, rejectTemplate} from "../index";
import _ from "lodash";

class ReviewModalController {
  constructor(AuthenticationService, $http, $uibModalInstance, $rootScope, timesheet, additionalTimesheets){
    "ngInject";
    this.timesheet = timesheet[0];
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$uibModalInstance = $uibModalInstance;
    this.additionalTimesheets = additionalTimesheets;
    var self = this;
    self.authenticationService = AuthenticationService;
    self.name = "timesheetDetail";

    this.loadTimesheet(this.timesheet);
  }

  loadTimesheet(timesheet) {
    let self = this;

    let ts = _.find(self.additionalTimesheets, function (obj) {
      return obj.id === timesheet.id
    });

    self.$http.get(self.$rootScope.apiHost+"/api/review/timesheets/"+timesheet.id, {withCredentials: true})
      .then((response) => {
        self.timesheet = response.data;
        self.timesheet.prevTimeSheetId = ts.prevTimeSheetId;
        self.timesheet.nextTimeSheetId = ts.nextTimeSheetId;
        self.timesheet.timesheetDates = self.getTimesheetDates(self.timesheet.startDate, self.timesheet.endDate);
    })
  }

  getTimesheetDates(startDate, endDate) {
    let dates = [];
    let currentDate = moment(startDate);
    let momentEndDate = moment(endDate);

    while(currentDate <= momentEndDate){
      dates.push(moment(currentDate).format("YYYY-MM-DD"));
      currentDate = moment(currentDate).add(1, 'days');
    }

    return dates;
  }

  nextTimesheet() {
    if(this.timesheet.nextTimeSheetId > 0) {
      this.loadTimesheet({id: this.timesheet.nextTimeSheetId});
    }
  }

  previousTimesheet() {
    if(this.timesheet.prevTimeSheetId > 0) {
      this.loadTimesheet({id: this.timesheet.prevTimeSheetId });
    }
  }

  canApprove(timesheet) {
    return timesheet.status !== 'SUBMITTED';
  }

  canReject(timesheet) {
    return timesheet.status === 'REJECTED' || timesheet.status === 'OPEN';
  }

  approveTimesheet(timesheet) {
    let self = this;
     self.$http.post(self.$rootScope.apiHost+"/api/review/timesheets/"+timesheet.id+"?action=APPROVE", {}, {withCredentials: true}).then(function (success) {
        self.loadTimesheet(success.data);
     });
  }

  rejectTimesheet(timesheet) {
    let self = this;
    self.$http.post(self.$rootScope.apiHost+"/api/review/timesheets/"+timesheet.id+"?action=REJECT", {}, {withCredentials: true}).then(function (success) {
      self.loadTimesheet(success.data);
    });
  }

  cancel(){
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default ReviewModalController;



// WEBPACK FOOTER //
// ./client/pages/review/modals/review/controller.js